export function isNullOrWhitespace(input: string) {
  if (typeof input === "undefined" || input == null) return true;

  return input.replace(/\s/g, "").length < 1;
}

export function titleCase(inp: string) {
  return inp
    .split(" ")
    .map((s) => s.charAt(0).toUpperCase() + s.substr(1))
    .join(" ");
}

export function prepareColorForDarkMode(hexInput: string | null | undefined) {
  return adjust(hexInput, -50);
}

export function adjust(
  hexInput?: string | null,
  percent?: number,
): string | undefined {
  if (!hexInput) return undefined;
  if (hexInput.length < 1) return hexInput;
  if (!percent) return hexInput;

  let hex = hexInput;

  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, "");

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  let r = parseInt(hex.substr(0, 2), 16);
  let g = parseInt(hex.substr(2, 2), 16);
  let b = parseInt(hex.substr(4, 2), 16);

  const calculatedPercent = (100 + percent) / 100;

  r = Math.round(Math.min(255, Math.max(0, r * calculatedPercent)));
  g = Math.round(Math.min(255, Math.max(0, g * calculatedPercent)));
  b = Math.round(Math.min(255, Math.max(0, b * calculatedPercent)));

  const toHex = (n: number) => n.toString(16).toUpperCase().padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
